var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLocationSunworld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.44501C1 4.67842 3.99969 1.625 7.7 1.625C11.4003 1.625 14.4 4.67842 14.4 8.44501C14.4 12.1821 12.2616 16.5429 8.92521 18.1023C8.14744 18.4659 7.25256 18.4659 6.47479 18.1023C3.13841 16.5429 1 12.1821 1 8.44501Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.7,
    cy: 8.325,
    r: 2.5125,
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationSunworld);
export default __webpack_public_path__ + "static/media/icon_location_sunworld.a0d27818c5950fe5fb57b8fcec24e090.svg";
export { ForwardRef as ReactComponent };